import { SailorCheckListItemRow } from "./SailorCheckListItemRow";
import { getSailorLink } from "../util";
import { CheckListItemRow } from "@poseidon/ui/components/CheckListTable";
import * as PropTypes from "prop-types";

export function SailorCheckListItemPersonalDetails({
  sailorId,
  applicationId,
  status,
  applicantType,
}) {
  return (
    <SailorCheckListItemRow
      status={status}
      applicantType={applicantType}
      label="Personal Details"
      tooltip="Name/Address etc."
      manageLink={getSailorLink(sailorId, applicationId)}
      manageText="Edit sailor"
    />
  );
}

export function SailorCheckListItemIncomeDetails({
  applicantType,
  applicationId,
  sailorId,
  status,
}) {
  return (
    <SailorCheckListItemRow
      status={status}
      applicantType={applicantType}
      label="Income Details"
      tooltip="Salary/Assets/Liabilities"
      manageLink={getSailorLink(sailorId, applicationId)}
      manageText="Edit sailor"
    />
  );
}

export function SailorCheckListItemSupportingDocumentation({
  applicantType,
  applicationId,
  sailorId,
  status,
}) {
  return (
    <SailorCheckListItemRow
      status={status}
      applicantType={applicantType}
      label="Supporting Documentation"
      tooltip="Proof of income etc."
      manageLink={`${getSailorLink(
        sailorId,
        applicationId
      )}/creditUnderwriting`}
      manageText="Go to Sailor Credit Underwriting"
    />
  );
}

export function SailorCheckListItemKycAmlConsent({
  applicationId,
  jointSailorId,
  sailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="KYC/AML Consent"
      tooltip="Has sailor given consent question regarding KYC/AML checks?"
      manageLink={getSailorLink(sailorId, applicationId)}
      manageText="Edit sailor"
      secondaryLink={getSailorLink(jointSailorId, applicationId)}
      secondaryLinkText="Edit joint sailor"
    />
  );
}

export function SailorCheckListItemOpenBankingConsent({
  applicationId,
  jointSailorId,
  sailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="Open Banking Consent"
      tooltip="Has sailor answered consent question regarding Open Banking"
      manageLink={getSailorLink(sailorId, applicationId)}
      manageText="Edit sailor"
      secondaryLink={getSailorLink(jointSailorId, applicationId)}
      secondaryLinkText="Edit joint sailor"
    />
  );
}

export function SailorCheckListItemKycAmlCheckDone({
  applicationId,
  jointSailorId,
  sailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="KYC AML Check Done"
      tooltip="Has the KYC/AML checks been done and passed?"
      manageLink={`${getSailorLink(sailorId, applicationId)}/identityChecks`}
      manageText="Go to Identity checks"
      secondaryLink={getSailorLink(
        jointSailorId,
        applicationId,
        "/identityChecks"
      )}
      secondaryLinkText="Go to joint sailor Identity checks"
    />
  );
}
export function SailorCheckListItemKycAmlDesignation({
  applicationId,
  jointSailorId,
  sailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="KYC AML Designation Set"
      tooltip="Has the KYC/AML designation been set?"
      manageLink={`${getSailorLink(sailorId, applicationId)}/identityChecks`}
      manageText="Go to Identity checks"
      secondaryLink={getSailorLink(
        jointSailorId,
        applicationId,
        "/identityChecks"
      )}
      secondaryLinkText="Go to joint sailor Identity checks"
    />
  );
}

export function SailorCheckListItemIdvUnblocked({
  applicationId,
  sailorId,
  jointSailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="ID&V Unblocked"
      tooltip="Has ID Verification been unblocked"
      manageLink={`${getSailorLink(sailorId, applicationId)}/identityChecks`}
      manageText="Go to Identity checks"
      secondaryLink={getSailorLink(
        jointSailorId,
        applicationId,
        "/identityChecks"
      )}
      secondaryLinkText="Go to joint sailor Identity checks"
    />
  );
}
export function SailorCheckListItemIdVerified({
  applicationId,
  sailorId,
  jointSailorId,
  status,
}) {
  return (
    <CheckListItemRow
      status={status}
      label="ID Verified"
      tooltip="Have both applicants ID verification been done and passed?"
      manageLink={`${getSailorLink(sailorId, applicationId)}/identityChecks`}
      manageText="Go to Identity checks"
      secondaryLink={getSailorLink(
        jointSailorId,
        applicationId,
        "/identityChecks"
      )}
      secondaryLinkText="Go to joint sailor Identity checks"
    />
  );
}

SailorCheckListItemPersonalDetails.propTypes = {
  status: PropTypes.any,
  applicant: PropTypes.any,
  applicationId: PropTypes.any,
};

SailorCheckListItemIncomeDetails.propTypes = {
  status: PropTypes.any,
  applicantType: PropTypes.string,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
};

SailorCheckListItemSupportingDocumentation.propTypes = {
  status: PropTypes.any,
  applicantType: PropTypes.string,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
};

SailorCheckListItemKycAmlConsent.propTypes = {
  status: PropTypes.any,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
  jointSailorId: PropTypes.any,
};

SailorCheckListItemOpenBankingConsent.propTypes = {
  status: PropTypes.any,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
  jointSailorId: PropTypes.any,
};

SailorCheckListItemKycAmlCheckDone.propTypes = {
  status: PropTypes.any,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
  jointSailorId: PropTypes.any,
};

SailorCheckListItemIdVerified.propTypes = {
  status: PropTypes.any,
  sailorId: PropTypes.string,
  applicationId: PropTypes.any,
  jointSailorId: PropTypes.any,
};
